import * as React from 'react';
import { ModalBody } from './modalbody/modalBody';
import { ModalBodyForLC } from './modalbody/modalBodyForLC';
import { ModalBodyForFSP } from './modalbody/modalBodyForFSP';
import { IBasketModal } from '../../types/properties';
import ModalWrapper from '../modalwrapper/modalwrapper';
import ModalFooter from './modalfooter/modalFooter';
import CrossSelling from '../basketmodal/crossSelling/crossSelling';
import style from '../modal.scss';

export default class BasketModal extends React.Component<IBasketModal> {
    private modalInnerContainerRef = React.createRef<HTMLDivElement>();
    constructor(props: IBasketModal) {
        super(props);
        this.handleRedirect = this.handleRedirect.bind(this);
        this.keyDDown = this.keyDDown.bind(this);
        this.toggleDebugMode = this.toggleDebugMode.bind(this);
    }

    componentDidMount() {
        if(this.modalInnerContainerRef && this.modalInnerContainerRef.current)
            this.modalInnerContainerRef.current.setAttribute('group', '');

        if (this.props.isPreview) 
            window.addEventListener('keydown', this.keyDDown);
    }

    componentWillUnmount() {
        if (this.props.isPreview)
            window.removeEventListener('keydown', this.keyDDown);
    }

    render() {
        const renderFSPBody = this.props.enableFlexibleSetPage && this.props.data && this.props.data.flexSetId &&
            !this.props.dataForLC;

        return (
            <>
                {
                    (this.props.data || this.props.dataForLC) &&
                    <ModalWrapper
                        title={this.props.localization.basket}
                        onClose={this.props.onIsOpenChange}
                        closeBtnTitle={this.props.localization.commonClose}
                    >
                        <div className={style.inner_content} ref={this.modalInnerContainerRef}
                            data-testid='modalInnerContainer' data-semantic-id='modalInnerContainer'>
                            {
                                this.props.dataForLC && !this.props.data &&
                                    <ModalBodyForLC
                                        model={this.props.dataForLC}
                                        localization={this.props.localization}
                                        cdnHost={this.props.cdnHost} />
                            }
                            {
                                renderFSPBody &&
                                <ModalBodyForFSP
                                    model={this.props.data}
                                    localization={this.props.localization}
                                    cdnHost={this.props.cdnHost} />
                            }
                            {
                                this.props.data && !renderFSPBody && !this.props.dataForLC &&
                                    <ModalBody
                                        model={this.props.data}
                                        localization={this.props.localization}
                                        cdnHost={this.props.cdnHost} />
                            }
                            {
                                !renderFSPBody && this.props.amsResponse?.crossSellings?.length > 0 &&
                                <CrossSelling
                                    amsResponse={this.props.amsResponse}
                                    localization={this.props.localization}
                                    priceMode={this.props.priceMode}
                                    cdnHost={this.props.cdnHost}
                                />
                            }
                        </div>
                        <ModalFooter
                                onClose={this.props.onIsOpenChange}
                                onContinue={this.handleRedirect}
                                localization={this.props.localization}
                                isLC={this.props.dataForLC && this.props.data === null}
                                smakeId={this.props.dataForLC?.smakeId}
                        />
                    </ModalWrapper>
                }
            </>
        )
    }

    private handleRedirect() {
        this.props.onIsOpenChange(true);
        location.href = this.props.localization.basketLink;
    }

    private keyDDown(event: KeyboardEvent) {
        if (event.key === 'd') {
            this.toggleDebugMode(); 
        }
    }

    public toggleDebugMode() {
        if (this.modalInnerContainerRef.current) {
            this.modalInnerContainerRef.current.classList.toggle('bm-debug');
        }
    }
}

